<template>
  <AppRadioGroup
    v-model="processor"
    :label="$tt('select_payment_method')"
    hide-details bold-label
  >
    <AppRadio v-for="{ label, value } in processors" :label :value />
  </AppRadioGroup>
</template>

<script setup lang="ts">
import type { PaymentProcessor } from '~/types';

type Option = { label: string; value: PaymentProcessor; mobile?: boolean };

const processor = defineModel<PaymentProcessor>({ required: true });
const props = defineProps<{
  noMobile?: boolean;
}>();

const { tt } = useLocalization();
const ALL_PROCESSORS: Readonly<Option[]> = [
  { label: tt('payment_processors.credit_card_ru'), value: 'tbank' },
  { label: tt('payment_processors.credit_card'), value: 'stripe' },
  { label: tt('payment_processors.bill_payment'), value: 'bill' },
  { label: tt('payment_processors.paypal'), value: 'paypal' },
  { label: tt('payment_processors.bit'), value: 'bit', mobile: true },
  { label: tt('payment_processors.paybox'), value: 'paybox', mobile: true }
];

const { paymentProcessors } = useBranch();
const processors = ALL_PROCESSORS.filter(p => {
  if (props.noMobile && p.mobile) return false;
  return paymentProcessors.includes(p.value);
});
</script>